import React from 'react';
import { Collapse } from 'react-bootstrap';
import { Stopwatch, Speedometer2 } from 'react-bootstrap-icons';
import FeedbackRate from './FeedbackRate';
import Chip from '../../../Chip/Chip';
import { ChipBackgroundColor, ChipLabelColor } from '../../../Chip/types';
import CareMapprButton from '../../../Button/CareMapprButton';
import CareMapprDropdown from '../../../Dropdown/CareMapprDropdown';
import CareMapprTextField from '../../../Inputs/textField/CareMapprTextField';

const urgentOptions = [
  { value: 'today', label: 'Today' },
  { value: 'tomorrow', label: 'Tomorrow' },
  { value: 'this_week', label: 'This week' },
];
const effortOptions = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
  { value: 'complex', label: 'Complex' },
];

const PrioritisationFeedback = ({ open }) => {
  const [urgent, setUrgent] = React.useState({
    value: 'today',
    label: 'Today',
  });
  const [effort, setEffort] = React.useState({
    value: 'complex',
    label: 'Complex',
  });

  const onSelectUrgent = (selected) => {
    setUrgent(selected);
  };
  const onSelectEffort = (selected) => {};
  return (
    <Collapse in={open}>
      <div>
        <div className="d-flex flex-column gap-3 mt-3">
          <div className="feedback-title">Your feedback</div>
          <FeedbackRate
            title="Rate the accuracy of"
            type="Urgency"
            chip={<Chip labelText="Today" icon={<Stopwatch size={12} />} />}
            rate={3.5}
          />
          <FeedbackRate
            title="Rate the accuracy of"
            type="Effort"
            chip={
              <Chip
                labelText="Medium"
                icon={<Speedometer2 size={12} />}
                backgroundColor={ChipBackgroundColor.YELLOW}
                labelColor={ChipLabelColor.YELLOW}
              />
            }
            rate={2}
          />
          <div className="feedback-fields">
            <div>
              If you have time, please provide more comprehensive feedback using
              the optional fields below:
            </div>
            <div className="feedback-form">
              <CareMapprDropdown
                labelClassName="feedback-form-label"
                label="How urgent did you think reviewing the patient was?"
                options={urgentOptions}
                value={urgent}
                onChange={onSelectUrgent}
              />
              <CareMapprDropdown
                labelClassName="feedback-form-label"
                label="How much effort was this patient’s review"
                options={effortOptions}
                value={effort}
                onChange={onSelectEffort}
              />
              <CareMapprDropdown
                labelClassName="feedback-form-label"
                label="Which (if any) risk criteria would you add:"
                options={[]}
              />
              <CareMapprDropdown
                labelClassName="feedback-form-label"
                label="Which (if any) risk criteria would you add:"
                options={[]}
              />
              <CareMapprDropdown
                labelClassName="feedback-form-label"
                label="Which (if any) criteria would you remove:"
                options={[]}
              />
              <CareMapprTextField
                labelClassName="feedback-form-label"
                label="Further feedback:"
                className="mb-5"
              />
            </div>
          </div>
          <div className="feedback-submit">
            <CareMapprButton label="Submit" extraClassNames="submit-button" />
          </div>
        </div>
      </div>
    </Collapse>
  );
};

export default PrioritisationFeedback;
